export const Z = {
	under: -1,
	zero: 0,
	over: 1,
	menu: 5,
	toolbar: 10,
	modal: 100,
	toast: 1000,
	above: (z: number) => z + 1,
};
